import Api from "../apiService";

class attributesApi {
  renderAttributes(companyId, params) {
    return Api.getRequest(
      `companies/${companyId}/attributes`,
      params,
      Api.authHeaders()
    );
  }
}

export default new attributesApi();
